import { ModuleTitle } from "@/components/patria/ModuleTitle";

export default function ModuleTitleRESOURCES({ className }) {
  return (
    <ModuleTitle
      className={className || "patria-module-title text-lg sm:text-xl"}
      testId="module-title-resources"
    >
      <span>RESOURCES</span>
      <span className="text-xs uppercase tracking-widest text-charcoal-muted">
        Playbooks, Forms &amp; Helpful Links
      </span>
    </ModuleTitle>
  );
}
